import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { setBreadcrumb } from 'components/Navbar/modules';
import { updateProfile } from 'routes/Profile/modules/actions';
import { resetAll } from 'modules/steps/actions';
import { uploadImage } from 'routes/Signup/modules/signup';
import ProfileEdit from '../components';

function mapStateToProps(state) {
  return {
    literals: state.i18n.literals.profileEdit,
    actualUser: state.session.user,
    app: state.app,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    uploadImage: bindActionCreators(uploadImage, dispatch),
    updateProfile: bindActionCreators(updateProfile, dispatch),
    setBreadcrumb: bindActionCreators(setBreadcrumb, dispatch),
    resetAll: bindActionCreators(resetAll, dispatch),
  };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ProfileEdit));



// WEBPACK FOOTER //
// ./src/routes/ProfileEdit/container/index.js